import { render, staticRenderFns } from "./PropertyHoldDesignRoyalTower.vue?vue&type=template&id=3e222f26&scoped=true&"
import script from "./PropertyHoldDesignRoyalTower.vue?vue&type=script&lang=js&"
export * from "./PropertyHoldDesignRoyalTower.vue?vue&type=script&lang=js&"
import style0 from "./PropertyHoldDesignRoyalTower.vue?vue&type=style&index=0&id=3e222f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e222f26",
  null
  
)

export default component.exports